import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TaskCardComponent } from './task-card/task-card.component';
import { PageBannerComponent } from './page-banner/page-banner.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { StepsComponent } from './steps/steps.component';
import { ContactCardComponent } from './contact-card/contact-card.component';
import { NewContactCardComponent } from './new-contact-card/new-contact-card.component';
import { ModalComponent } from './modal/modal.component';
import { DateTimeCheckboxComponent } from './date-time-checkbox/date-time-checkbox.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';

import { GetInitialsPipe } from './pipes/get-initials.pipe';

@NgModule({
    declarations: [
        TaskCardComponent,
        PageBannerComponent,
        ToolbarComponent,
        StepsComponent,
        ContactCardComponent,
        NewContactCardComponent,
        ModalComponent,
        DateTimeCheckboxComponent,
        UserAvatarComponent,
        GetInitialsPipe
    ],
    imports: [CommonModule, FormsModule],
    exports: [
        TaskCardComponent,
        PageBannerComponent,
        ToolbarComponent,
        StepsComponent,
        ContactCardComponent,
        NewContactCardComponent,
        ModalComponent,
        DateTimeCheckboxComponent,
        UserAvatarComponent
    ]
})
export class ZoomUiModule {}
